import AvailableIcon from 'assets/images/icon-available.svg?react';
import ChargingIcon from 'assets/images/icon-charging.svg?react';
import ConnectedIcon from 'assets/images/icon-connected.svg?react';
import FaultedIcon from 'assets/images/icon-faulted.svg?react';
import FinishingIcon from 'assets/images/icon-finishing.svg?react';
import ReservedIcon from 'assets/images/icon-reserved.svg?react';
import SuspendedEVIcon from 'assets/images/icon-suspended-ev.svg?react';
import SuspendedEVSEIcon from 'assets/images/icon-suspended-evse.svg?react';
import UnavailableIcon from 'assets/images/icon-unavailable.svg?react';
import CCS1SVG from 'assets/images/plug-ccs1.svg?react';
import CCS2SVG from 'assets/images/plug-ccs2.svg?react';
import CHAdeMOSVG from 'assets/images/plug-chademo.svg?react';
import GbtAcSvg from 'assets/images/plug-gbt-ac.svg?react';
import GbtDcSvg from 'assets/images/plug-gbt-dc.svg?react';
import J1772SVG from 'assets/images/plug-j1772.svg?react';
import MennekesSVG from 'assets/images/plug-mennekes.svg?react';
import TeslaSVG from 'assets/images/plug-tesla.svg?react';
import NoPlugSVG from 'assets/images/plug.svg?react';
import ConnectorTypes from 'constants/ConnectorTypes';
import { ChargePointStatusEnum, ConnectorStatusEnum, type PlugTypeEnum } from 'types/swagger';

interface Connector {
  plug_type?: string;
  latest_status_notification: {
    status: string;
  } | null;
  id: number;
}

export const getConnectorTypeSvg = (connector: Connector | null, size?: string) => {
  switch (connector?.plug_type) {
    case ConnectorTypes.NO_PLUG: {
      return <NoPlugSVG height={size} width={size} />;
    }
    case ConnectorTypes.CCS1: {
      return <CCS1SVG height={size} width={size} />;
    }
    case ConnectorTypes.CCS2: {
      return <CCS2SVG />;
    }
    case ConnectorTypes.CHADEMO: {
      return <CHAdeMOSVG height={size} width={size} />;
    }
    case ConnectorTypes.TESLA: {
      return <TeslaSVG height={size} width={size} />;
    }
    case ConnectorTypes.GBTDC: {
      return <GbtDcSvg height={size} width={size} />;
    }
    case ConnectorTypes.GBTAC: {
      return <GbtAcSvg height={size} width={size} />;
    }
    case ConnectorTypes.J1772: {
      return <J1772SVG height={size} width={size} />;
    }
    case ConnectorTypes.MENNEKES: {
      return <MennekesSVG height={size} width={size} />;
    }
    default: {
      return <NoPlugSVG height={size} width={size} />;
    }
  }
};

export const getConnectorIconByPlugType = (plugType: PlugTypeEnum, size?: string) => {
  switch (plugType) {
    case ConnectorTypes.NO_PLUG: {
      return <NoPlugSVG height={size} width={size} />;
    }
    case ConnectorTypes.CCS1: {
      return <CCS1SVG height={size} width={size} />;
    }
    case ConnectorTypes.CCS2: {
      return <CCS2SVG />;
    }
    case ConnectorTypes.CHADEMO: {
      return <CHAdeMOSVG height={size} width={size} />;
    }
    case ConnectorTypes.TESLA: {
      return <TeslaSVG height={size} width={size} />;
    }
    case ConnectorTypes.GBTDC: {
      return <GbtDcSvg height={size} width={size} />;
    }
    case ConnectorTypes.GBTAC: {
      return <GbtAcSvg height={size} width={size} />;
    }
    case ConnectorTypes.J1772: {
      return <J1772SVG height={size} width={size} />;
    }
    case ConnectorTypes.MENNEKES: {
      return <MennekesSVG height={size} width={size} />;
    }
    default: {
      return <NoPlugSVG height={size} width={size} />;
    }
  }
};

export const getConnectorStatusSvg = (connector: Connector | null) => {
  const statusNotification = connector?.latest_status_notification;
  const status = statusNotification ? statusNotification.status : ConnectorStatusEnum.Available;
  switch (status) {
    case ConnectorStatusEnum.Charging:
      return <ChargingIcon />;
    case ConnectorStatusEnum.Preparing:
      return <ConnectedIcon />;
    case ConnectorStatusEnum.Finishing:
      return <FinishingIcon />;
    case ConnectorStatusEnum.Available:
      return <AvailableIcon />;
    case ConnectorStatusEnum.Faulted:
      return <FaultedIcon />;
    case ConnectorStatusEnum.Unavailable:
      return <UnavailableIcon />;
    case ConnectorStatusEnum.SuspendedEV:
      return <SuspendedEVIcon />;
    case ConnectorStatusEnum.SuspendedEVSE:
      return <SuspendedEVSEIcon />;
    case ConnectorStatusEnum.Reserved:
      return <ReservedIcon />;
    default:
      return null;
  }
};

export const getConnectorStatusIcon = (
  status: ChargePointStatusEnum,
  width?: string,
  height?: string
) => {
  switch (status) {
    case ChargePointStatusEnum.Charging:
      return <ChargingIcon width={width} height={height} />;
    case ChargePointStatusEnum.Preparing:
      return <ConnectedIcon width={width} height={height} />;
    case ChargePointStatusEnum.Finishing:
      return <FinishingIcon width={width} height={height} />;
    case ChargePointStatusEnum.Available:
      return <AvailableIcon width={width} height={height} />;
    case ChargePointStatusEnum.Faulted:
      return <FaultedIcon width={width} height={height} />;
    case ChargePointStatusEnum.Unavailable:
      return <UnavailableIcon width={width} height={height} />;
    case ChargePointStatusEnum.SuspendedEV:
      return <SuspendedEVIcon width={width} height={height} />;
    case ChargePointStatusEnum.SuspendedEVSE:
      return <SuspendedEVSEIcon width={width} height={height} />;
    case ChargePointStatusEnum.Reserved:
      return <ReservedIcon width={width} height={height} />;
    default:
      return null;
  }
};

interface ConnectorTypeProps {
  connector: Connector | null;
}

const ConnectorType = ({ connector }: ConnectorTypeProps) => {
  return (
    <div className="connector-type-icon d-flex align-items-center justify-content-center">
      {getConnectorStatusSvg(connector)}
    </div>
  );
};

ConnectorType.defaultProps = {
  size: '100px',
};

export default ConnectorType;
